import { queryOptions, useQuery } from '@tanstack/react-query';

import { accountApi } from '../api/account-api';

import { accountKeys } from './account-keys';

export function sessionsQueryOptions() {
  return queryOptions({ queryKey: accountKeys.sessions(), queryFn: accountApi.sessions });
}

export function useSessions() {
  return useQuery(sessionsQueryOptions());
}
